import { render, staticRenderFns } from "./BatchDetail.vue?vue&type=template&id=0d407e0f&scoped=true"
import script from "./BatchDetail.vue?vue&type=script&lang=js"
export * from "./BatchDetail.vue?vue&type=script&lang=js"
import style0 from "./BatchDetail.vue?vue&type=style&index=0&id=0d407e0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d407e0f",
  null
  
)

export default component.exports